'use client'

import {observer} from 'mobx-react'
import React from 'react'

import {useProductViewModel} from '@/src/entities/product'
import {isSimpleProduct, productHasManyVariants} from '@/src/entities/product/helpers'
import {ProductViewModel, ProductWithVariantsListItemViewModel} from '@/src/entities/product/model'

import * as UI from './offers.styled'

interface IValueProps extends React.PropsWithChildren {
  className?: string
  disabled?: boolean
  active?: boolean
  hidden?: boolean
  onChange: () => void
}

export const OfferValue = ({children, onChange, active, disabled, hidden, className}: IValueProps) => {
  return (
    <UI.OfferValue
      outlined={!active}
      primary={active}
      className={className}
      disabled={disabled}
      hidden={hidden}
      onClick={onChange}>
      {children}
    </UI.OfferValue>
  )
}

const withVariantsGuard = (
  productViewModel: ProductViewModel,
): productViewModel is ProductWithVariantsListItemViewModel =>
  'variants' in productViewModel &&
  !isSimpleProduct(productViewModel.product) &&
  productHasManyVariants(productViewModel.product)

export const ProductOffers = observer(() => {
  const productViewModel = useProductViewModel()

  if (!withVariantsGuard(productViewModel)) {
    return <></>
  }

  return (
    <UI.Offers>
      {productViewModel.variants.attributes.map(attribute => (
        <UI.OfferContainer key={attribute.code}>
          <h2>{attribute.name}</h2>
          <UI.OfferValues>
            {productViewModel.variants.getAttributeValues(attribute.code).map(attributeValue => (
              <OfferValue
                key={attributeValue.value}
                active={attributeValue.active}
                disabled={attributeValue.disabled || !attributeValue.available}
                onChange={() => productViewModel.variants.setSelectedAttribute(attribute.code, attributeValue.value)}>
                {attributeValue.title}
              </OfferValue>
            ))}
          </UI.OfferValues>
        </UI.OfferContainer>
      ))}
    </UI.Offers>
  )
})
